import { FC, MouseEvent } from "react";
import useEvent from "react-use-event-hook";

import { useDrawers, useHaveCustomPermissions } from "@ryde/shared";

import { ICoursesCalendarRideProduceRideLinkProps } from "./courses-calendar-ride-produce.models";

export const CoursesCalendarRideProduceRideLink: FC<
  ICoursesCalendarRideProduceRideLinkProps
> = ({ rideId }) => {
  const { openRideEditFormDrawer } = useDrawers();
  const { hasPermissionEditRide, hasPermissionViewRide } =
    useHaveCustomPermissions();
  const canOpenRideDrawer = hasPermissionEditRide || hasPermissionViewRide;

  const onRideClick = useEvent((event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (!canOpenRideDrawer) {
      return;
    }
    void openRideEditFormDrawer({ id: rideId });
  });

  if (!canOpenRideDrawer) {
    return <span className="cc-ride-produce-ride-id">{rideId}</span>;
  }

  return (
    <button
      type="button"
      className="cc-ride-produce-ride-link"
      onClick={onRideClick}
    >
      {rideId}
    </button>
  );
};
